import axios from "axios";
import { io } from "socket.io-client";
// import debug from "debug";
// debug.enable("socket.io-client:*");

const currentURL = window.location.href;
export const Tenantname = currentURL.split(".")[0].split("//")[1];

export const TENANTS_WITHOUT_REQUIRED_FIELD = ["relux"];

// export const BASE_URL = "https://127.0.0.1:8000";        // local

// export const BASE_URL = "http://51.20.141.90:8000";        // aws server

// export const BASE_URL = "https://3.238.104.144:8000";      // aws server new

// export const BASE_URL = "https://65.2.52.192:8000";         // new server

// export const BASE_URL = "https://69.197.176.205:8000";        // new live server

export const BASE_URL = `https://backend.felixhr.com/${Tenantname}`;        // new live server
// export const BASE_URL = `https://127.0.0.1:8000/${Tenantname}`;        // new live server

export const Super_Admin_URL = "https://69.197.176.205:8000";        // new live server



// socket connection
export const socket = io("ws://admin.ineedgig.co.in:8001", {
  transports: ["websocket", "polling"],
  autoConnect: false,
});


const token = localStorage.getItem("accesstoken");

export const header = {
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "*/*",
    Accept: "application/json",
  },
};


const authServices = {};


authServices.getCurrentUser = async (username) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Usersignup/?username=${username}`
  );
  return data;
};

authServices.signIn = async (username, password) => {
  const data = await axios.post(`${BASE_URL}/auth_token`, {
    username,
    password,
  });
  return data;
};

export default authServices;
